/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import {
  Dropdown,
  Icon,
} from 'semantic-ui-react';
import { TRANSLATION_FILES } from '../../../constants/translation';

class CustomDropdownPrivacy extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    showInternalPrivacy: PropTypes.bool,
    privacyValue: PropTypes.string,
    t: PropTypes.func,
  };
  constructor(props) {
    super(props);
    this.state = {
      onFocus: false,
    };
  }
  handleDDChange = (e, { value }) => {
    e.preventDefault();
    this.setState({ value, onFocus: false }, () => {
      if (this.props.onChange) this.props.onChange(value);
    });
  };
  handleOnClickChange = () => {
    this.setState({ onFocus: !this.state.onFocus });
  }
  render() {
    const { showInternalPrivacy, privacyValue, t } = this.props;
    const { onFocus } = this.state;
    const privacyOptions = [
      { key: 'public', value: 'public', text: (<span><Icon name="globe" /> {t('Public')}</span>) },
    ];
    if (showInternalPrivacy) {
      privacyOptions.push({ key: 'internal', value: 'internal', text: (<span><Icon name="users" /> {t('Internal')}</span>) });
    }
    privacyOptions.push({ key: 'private', value: 'private', text: (<span><Icon name="lock" /> {t('Only Me')}</span>) });
    return (
      <div className="rdw-custom-dropdown-privacy">
        <Dropdown
          disabled={privacyValue === ''}
          fluid
          onChange={this.handleDDChange}
          onClick={this.handleOnClickChange}
          open={onFocus}
          options={privacyOptions}
          selection
          selectOnBlur={false}
          value={privacyValue || 'public'}
        />
      </div>
    );
  }
}

export default withTranslation(TRANSLATION_FILES.constants)(CustomDropdownPrivacy);



// WEBPACK FOOTER //
// ./src/components/BookingNote/NoteEditor/CustomDropdownPrivacy.jsx